import {
  isFunction as _isFunction,
  map as _map,
  get as _get,
  find as _find,
  toLower as _toLower,
  filter as _filter,
} from 'lodash';
import moment from 'moment';

import { findAndGet } from '@vfgroup-oneplatform/framework/Services/Utils/Utils';

import { CONTRACT_DATA_TYPES, USAGE_TYPES } from '../../../BusinessOverview/Utils/Enums';
import { USER_ROLES } from '../../../MyUsersAndGroups/Utils/Enums';
import { convertMB, convertMbTo } from '../../Utils';

const getFormattedDate = validFor => {
  const date = _get(validFor, 'endDateTime');
  return moment(date).format('DD/MM/YYYY');
};

const getContractDataLabel = name => {
  switch (name) {
    case CONTRACT_DATA_TYPES.RENEWAL:
      return 'soho_plans_plan_card_contract_data_renewal_date_label';
    case CONTRACT_DATA_TYPES.CONTRACT_END:
      return 'soho_plans_plan_card_contract_data_contract_ends_label';
    case CONTRACT_DATA_TYPES.MINIMUM_TERM_END:
      return 'soho_plans_plan_card_contract_data_minimum_term_ends_label';
    case CONTRACT_DATA_TYPES.ELIGIBLE_UPGRADE_FROM:
      return 'soho_plans_plan_card_contract_data_eligible_upgrade_from_label';
  }
  return '';
};

const mapUsageData = (plan, usageConsumptionReport, iconsMapper) => {
  const buckets = _filter(
    usageConsumptionReport[0].bucket,
    bucket => bucket.product[0].id === plan.id,
  );
  return _map(buckets, b => {
    const usage = {};
    usage.id = b.id;
    usage.name = b.name;
    let usageType = b.usageType;
    if (_toLower(usageType) === 'local calls') {
      usageType = USAGE_TYPES.CALLS;
    }
    usage.usageType = usageType;
    if (_isFunction(iconsMapper)) {
      usage.icon = iconsMapper(usageType);
    }
    const bucketCounter = b.bucketCounter;
    const totalValueName = findAndGet(bucketCounter, 'counterType', 'global', 'valueName');
    const isUnlimited = totalValueName === 'Unlimited';
    usage.isUnlimited = isUnlimited;
    const usedAmount = findAndGet(bucketCounter, 'counterType', 'used', 'value.amount');
    const usedUnits = findAndGet(bucketCounter, 'counterType', 'used', 'value.units');
    let { amount: convertedUsedAmount, units: convertedUsedUnits } = convertMB(
      usedUnits,
      usedAmount,
    );

    if (!isUnlimited) {
      const totalAmount = findAndGet(bucketCounter, 'counterType', 'global', 'value.amount');
      const totalUnits = findAndGet(bucketCounter, 'counterType', 'global', 'value.units');
      const { amount: convertedTotalAmount, units: convertedTotalUnits } = convertMB(
        totalUnits,
        totalAmount,
      );

      const { amount: _convertedUsedAmount, units: _convertedUsedUnits } = convertMbTo(
        convertedTotalUnits,
        usedAmount,
        usedUnits,
      );

      convertedUsedAmount = _convertedUsedAmount;
      convertedUsedUnits = _convertedUsedUnits;

      usage.totalAmount = convertedTotalAmount;
      usage.totalUnits = convertedTotalUnits;

      const remainingAmount = Number(
        parseFloat(convertedTotalAmount - convertedUsedAmount).toFixed(2),
      );

      usage.remainingAmount = remainingAmount;
      // multiplying 0.29 by 100 produces 28.99 instead of 29, so we multiply by 10 by 10 instead to get 29
      usage.valuePercentage = Math.floor(
        (remainingAmount / convertedTotalAmount) * 10 * 10,
      ).toString();
    }
    usage.remainingUnits = convertedUsedUnits;
    return usage;
  });
};

const mapUsers = plan => {
  const mappedUsers = [];
  plan.relatedParty.forEach(user => {
    const { id, name, role } = user;
    if (user['@type'] === 'individual') {
      mappedUsers.push({
        id,
        name,
        role,
        '@type': user['@type'],
        '@referredType': user['@referredType'],
      });
    }
  });
  return mappedUsers;
};

const mapUnassignedUsers = plan => {
  return _map(plan.unassignedUser, user => {
    const { id, fullName, relatedParty } = user;
    const relatedPartyObject = _find(
      relatedParty,
      u => _toLower(u.role) !== (USER_ROLES.USER || USER_ROLES.GRANTER),
    );
    return {
      id,
      name: fullName,
      role: relatedPartyObject?.role,
      '@type': user['@type'],
    };
  });
};

export { getFormattedDate, getContractDataLabel, mapUsageData, mapUsers, mapUnassignedUsers };
